import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from '../../WifiConnect.module.scss';

export type CorporateTabDescription = {
  network_name: string;
};

export const CorporateTabDescription: React.FC<CorporateTabDescription> = ({
  network_name,
}) => {
  return (
    <div className="ray-grid__cell--span-full" style={{ marginBottom: 15 }}>
      <span>
        <FormattedMessage
          id="tabs.corporate.description.messages.0"
          defaultMessage="Specific admins can use this tab to add, list and modify corporate IoT and team device MAC addresses."
        />
      </span>
      <br></br>
      <br></br>
      <span>
        <FormattedMessage
          id="tabs.corporate.description.messages.1"
          defaultMessage="Non-admin team Members should use the {network} tab to add corporate IoT and team device MAC addresses."
          values={{ network: <b>{network_name}</b> }}
        />
      </span>
    </div>
  );
};
